import { Injectable } from '@angular/core';

import { delay, Observable, of } from 'rxjs';

import { WithdrawalApiService } from '../api';
import { WithdrawalRes } from '../entities';

@Injectable()
export class WithdrawalMockApiService extends WithdrawalApiService {
  override withdrawal(): Observable<WithdrawalRes> {
    return of({
      operationId: 'mock-operation-id',
      status: 'success',
    }).pipe(delay(500));
  }
}
